const ANNUAL_UPGRADE_DEEPLINK_KEY = 'annualUpgradeDeeplink'
/** @see services/marketing/src/utils/getPricingTrialSignupUrl.ts */
export const START_TRIAL_DEEPLINK_KEY = 'startTrialDeeplink'
export const START_TRIAL_INTENT_QUERY_PARAM = 'intent'
export const START_TRIAL_CTA_QUERY_PARAM = 'cta'
export const START_TRIAL_INTENT = 'start-trial'
const PRICING_TRIAL_CTAS: ReadonlySet<string> = new Set([
  'bufferSite-pricing-cards-essentials-1',
  'bufferSite-pricing-cards-team-1',
  'bufferSite-pricing-tableTop-essentials-1',
  'bufferSite-pricing-tableTop-team-1',
])

if (window.location.pathname === '/upgrade-to-annual') {
  sessionStorage.setItem(ANNUAL_UPGRADE_DEEPLINK_KEY, 'true')
}

const urlParams = new URLSearchParams(window.location.search)

if (
  window.location.pathname === '/' &&
  urlParams.getAll(START_TRIAL_INTENT_QUERY_PARAM).includes(START_TRIAL_INTENT)
) {
  const cta = urlParams.get(START_TRIAL_CTA_QUERY_PARAM)

  sessionStorage.setItem(
    START_TRIAL_DEEPLINK_KEY,
    cta && PRICING_TRIAL_CTAS.has(cta) ? cta : '',
  )
}
